/**
 * Arduino Distributor Widget
 * Injected in the PDP (arduino-product.liquid)
 */

(function() {
    var partSearch = null;

    function onRender(data, additional) {
        const viewAllButton = document.querySelector('.di-view-all');
    
        // check if search was made successfully
        console.log(data);

        if(data.groups.length > 0) {
            const group = data.groups[0];

            const items = group.summary.results;
            const limit = group.settings.items_limit;

            // check if there are more items to show
            if(items > limit) {
                viewAllButton.classList.remove('hidden');
            }

            if(limit < 0) {
                viewAllButton.innerHTML = 'View fewer';
            } else {
                viewAllButton.innerHTML = 'View all';
            }

            viewAllButton.addEventListener('click', (event) => {
                event.preventDefault();

                if(limit > 0) {
                    partSearch.items.limit(-1);
                } else {
                    partSearch.items.limit(5);
                }

                partSearch.render();
            });
        }
    }

    function init() {
        const element = document.querySelector('[data-di-search-term]');

        if(!element) {
            return;
        }

        const api_key = 'm9x6skv533die9v558ks0eq48lctzenqmho4dvekmaof9c9x5kr0b73dvuoslv3j';
        const term = element.getAttribute('data-di-search-term');

        partSearch = DistributorInventory.search({
            key: api_key,
            search: {
                term: term,
                exact: true,
            },
            container: `[data-di-search-term="${term}"]`,
            manufacuturers: ['Arduino'],
            group: {
                field: 'part_by_manufacturer',
            },
            items: {
                order: ['quantity_in_stock', 'desc'],
                limit: 5,
            },
            render: {
                header: {
                    class: 'di-header',
                    build: function() {
                        return `
                            <span>Distributor Stock:</span>
                            <a class="di-view-all hidden" href="#">View all</a>
                        `;
                    }
                },
                footer: {
                    build: function() {
                        return '';
                    },
                },
                loading: {
                    class: 'di-loading',
                    build: function() {
                        return '';
                    }
                },
                failed: {
                    build: function() {
                        return '';
                    }
                },
                group: {
                    header: {
                        build: function() {
                            return ''
                        }
                    },
                    footer: {
                        build: function() {
                            return '';
                        }
                    },
                    table: {
                        thead: {
                            build: function() {
                                return '';
                            }
                        }
                    },
                    columns: [
                        {
                            field: 'distributor_logo',
                            class: 'di-logo',
                            build: function(data, reach) {
                                return `<img style="width: 75px" src="${data}">`
                            }
                        },
                        {
                            field: 'distributor_common_name',
                            class: 'di-name',
                            build: function(data) {
                                return `${data}`;
                            }
                        },
                        {
                            field: 'quantity_in_stock',
                            class: 'di-stock',
                            build: function(data, reach) {
                                return `${data} in stock`;
                            }
                        },
                        {
                            field: 'buy_now_url',
                            class: 'di-buy-now',
                            build: function(data, reach) {
                                return `
                                    <a href="${data}" target="_blank">
                                        <span>Buy</span>
                                        <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M1.00582 11.8907C1.09959 11.9844 1.22677 12.0371 1.35938 12.0371H12.3594C12.492 12.0371 12.6192 11.9844 12.7129 11.8907C12.8067 11.7969 12.8594 11.6697 12.8594 11.5371V7.53711C12.8594 7.4045 12.8067 7.27732 12.7129 7.18356C12.6192 7.08979 12.492 7.03711 12.3594 7.03711C12.2268 7.03711 12.0996 7.08979 12.0058 7.18356C11.9121 7.27732 11.8594 7.4045 11.8594 7.53711V11.0371H1.85938V1.03711H5.35938C5.49198 1.03711 5.61916 0.984431 5.71293 0.890663C5.8067 0.796894 5.85938 0.669718 5.85938 0.537109C5.85938 0.404501 5.8067 0.277324 5.71293 0.183556C5.61916 0.0897878 5.49198 0.0371094 5.35938 0.0371094H1.35938C1.22677 0.0371094 1.09959 0.0897878 1.00582 0.183556C0.912053 0.277324 0.859375 0.404501 0.859375 0.537109V11.5371C0.859375 11.6697 0.912053 11.7969 1.00582 11.8907ZM12.8594 5.03711V0.537109C12.8594 0.404501 12.8067 0.277324 12.7129 0.183556C12.6192 0.0897878 12.492 0.0371094 12.3594 0.0371094H7.85938C7.72677 0.0371094 7.59959 0.0897878 7.50582 0.183556C7.41205 0.277324 7.35938 0.404501 7.35938 0.537109C7.35938 0.669718 7.41205 0.796894 7.50582 0.890663C7.59959 0.984431 7.72677 1.03711 7.85938 1.03711H11.1494L6.50437 5.68211C6.45751 5.72859 6.42031 5.78389 6.39493 5.84482C6.36954 5.90575 6.35648 5.9711 6.35648 6.03711C6.35648 6.10312 6.36954 6.16847 6.39493 6.2294C6.42031 6.29033 6.45751 6.34563 6.50437 6.39211C6.55086 6.43897 6.60616 6.47617 6.66709 6.50156C6.72802 6.52694 6.79337 6.54001 6.85938 6.54001C6.92538 6.54001 6.99073 6.52694 7.05166 6.50156C7.11259 6.47617 7.16789 6.43897 7.21437 6.39211L11.8594 1.74711V5.03711C11.8594 5.16972 11.9121 5.29689 12.0058 5.39066C12.0996 5.48443 12.2268 5.53711 12.3594 5.53711C12.492 5.53711 12.6192 5.48443 12.7129 5.39066C12.8067 5.29689 12.8594 5.16972 12.8594 5.03711Z" fill="#00979D"/>
                                        </svg>
                                    </a>
                                `;
                            }
                        },
                    ]
                }
            },
            callbacks: {
                render: onRender
            }
        });
    }

    window.addEventListener('load', init);
})();